import React, { Component } from "react";
import { Button, Icon, Image, Modal } from "semantic-ui-react";
import Analysis from "features/FolderManager/components/Prescription/Analysis";
import AnalysisDetailsModal from "features/FolderManager/components/Prescription/AnalysisDetailsModal";

const styles = {
	headerAnalysisCircle: {
		padding: "1em",
		marginBottom: "2em",
		textAlign: "center",
	},
	circleAnalysis: {
		height: 50,
		width: 50,
		borderRadius: "50%",
		border: "1px solid #5f9be0",
		textAlign: "center",
		lineHeight: "48px",
		fontWeight: 600,
		color: "#5f9be0",
		cursor: "pointer",
		fontSize: "0.7em",
		boxShadow: "rgba(0, 0, 0, 0.14) 0px -5px 17px -5px inset, rgb(148, 148, 148) 0px 9px 13px -10px",
		margin: "auto",
	},
	circleTitle: {
		fontSize: "0.6em",
		height: 20,
		lineHeight: "1em",
		display: "flex",
		alignItems: "center",
	},
	tubesContainer: {
		display: "flex",
		width: "100%",
		flexWrap: "wrap",
	},
	tube: {
		maxWidth: 60,
		padding: "0.2em",
	},
};

class TubeDetailsModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			analysisDetailsModal: false,
			analysisDetailed: null,
		};
	}
	close = () => (this.props.open = false);
	openAnalysisDetailsModal = (analysis) => {
		this.setState({ analysisDetailsModal: true, analysisDetailed: analysis });
	};

	closeAnalysisDetailsModal = () => {
		this.setState({ analysisDetailsModal: false, analysisDetailed: null });
	};

	render() {
		const { analysisDetailsModal, analysisDetailed } = this.state;
		const { open, tube, close, urgencyPretreatementLimit } = this.props;
		return (
			<>
				<AnalysisDetailsModal open={analysisDetailsModal} close={this.closeAnalysisDetailsModal} analysis={analysisDetailed} isHome={false} />

				<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
					{tube !== null && (
						<Modal.Content>
							<div style={styles.headerAnalysisCircle}>
								<Image
									size="tiny"
									src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${
										tube.properties.picto !== null ? tube.properties.picto.filename : process.env.REACT_APP_TUBE_PIC_FILENAME
									}`}
									style={{ margin: "auto" }}
								/>
								{tube.properties.label}({tube.properties.code})
							</div>
							{tube !== null && tube.light_protected && (
								<div style={{ color: "#a53a12", fontWeight: 600 }}>
									<Icon className="warningIcon" size="small" name="warning" circular style={{ position: "relative", bottom: 2, marginLeft: 3 }} />À
									l'abri de la lumière
								</div>
							)}
							{tube !== null && tube.pretreatment_urgent && (
								<div style={{ color: "#a53a12", fontWeight: 600 }}>
									<Icon className="warningIcon" size="small" name="warning" circular style={{ position: "relative", bottom: 2, marginLeft: 3 }} />
									Pré-traitement urgent
								</div>
							)}
							<br />

							<div style={{ padding: "0 10%" }}>
								<div>Analyse(s) concernée(s) </div>
								{tube.analyses &&
									tube.analyses
										.sort((a, b) => (a.order < b.order ? -1 : a.order > b.order ? 1 : 0))
										.map((ana) => (
											<Analysis
												key={ana.id}
												analysis={ana}
												onClick={this.openAnalysisDetailsModal}
												showWarning={false}
												showLabel={true}
												isHome={false}
												stability_delay={true}
												urgencyPretreatementLimit={urgencyPretreatementLimit}
												showRefused={false}
											/>
										))}
							</div>
						</Modal.Content>
					)}

					<Modal.Actions>
						<Button
							onClick={(e) => {
								if (e !== undefined) e.preventDefault();
								close();
							}}
						>
							<Icon name="remove" /> Fermer
						</Button>
					</Modal.Actions>
				</Modal>
			</>
		);
	}
}

export default TubeDetailsModal;
